import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/rustomjee-logo.webp"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Rustomjee Group is a renowned Mumbai-based real estate developer known
        for its focus on quality, innovation, and community-driven design. With
        over 25 million sq. ft. delivered and 17,000+ happy families, Rustomjee
        has transformed the Mumbai skyline with residential, commercial, and
        township projects. Their developments span across prime locations from
        South Mumbai to Thane and Dombivli, offering everything from luxury
        residences to self-sufficient gated townships. Each home is designed for
        modern lifestyles—with premium amenities, green spaces, and smart
        connectivity. Projects include features like rooftop decks, clubhouses,
        kids' zones, and banquet spaces, creating vibrant, safe communities.
        Rustomjee's mission is to make luxury living accessible, blending
        opulence with thoughtful planning. Buyers enjoy the advantage of prime
        locations, community living, and a high quality of life. With decades of
        expertise, Rustomjee continues to redefine urban luxury and comfort
        across the Mumbai Metropolitan Region.
      </p>
      {/* 
      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/rera-P51800079537.jpeg" alt="rera qr" />
          <strong>P51800079537</strong>
        </div>
      </div> */}

      {/* <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span> */}

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
